import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bmscustomerfacilitytypepipe'
})
export class BmsCustomerFacilityTypePipe implements PipeTransform {

  constructor() {}

  transform(facilityType: string, ...args: unknown[]): string {

    switch (facilityType) {
      case 'Chargingstation':
        return  $localize `:@@customeradminfacility_chargingstation:Chargingstation`;

      case 'Local':
        return  $localize `:@@customeradminfacility_local:Local`;

      case 'Engineheater':
        return  $localize `:@@customeradminfacility_engineheater:Engineheater`;

      default:
        return  facilityType;
    }
    return  facilityType;
  }

}
